import React, { Fragment, useEffect } from 'react';
import { Portal, Transition } from '@headlessui/react';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import tw from 'twin.macro';
import { Infobox } from 'components/Callout/Infobox';

export default function Notifications() {
  const {
    isOpen,
    close,
    timeout,
    intent,
    icon,
    title,
    message,
    closable,
    actions,
    align = 'right',
    layout = 'inline',
  } = useNotification();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (isOpen) {
        close();
      }
    }, timeout);
    return () => clearTimeout(timer);
  }, [isOpen, timeout]);

  return (
    <Portal>
      {/* Global notification live region, render this permanently at the end of the document */}
      <div
        aria-live="assertive"
        tw="fixed top-0 right-0 left-0 bottom-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start z-50"
      >
        <div
          css={[
            tw`w-full h-full flex flex-col items-center justify-end space-y-4`,
            align === 'center' && tw`sm:items-center`,
            align === 'right' && tw`sm:items-end`,
            align === 'left' && tw`sm:items-start`,
          ]}
        >
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition
            show={isOpen}
            as={Fragment as any}
            enter="notifEnter"
            enterFrom="notifEnterFrom"
            enterTo="notifEnterTo"
            leave="notifLeave"
            leaveFrom="notifLeaveFrom"
            leaveTo="notifLeaveTo"
          >
            <div tw="max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
              <Infobox
                onClose={closable ? close : undefined}
                icon={icon as any}
                intent={intent}
                layout={layout}
                title={title}
                actions={actions}
              >
                {message}
              </Infobox>
            </div>
          </Transition>
        </div>
      </div>
    </Portal>
  );
}
